export default "__VITE_ASSET__BRVvhxv2__"